import React from "react";
import Header from "./Header";
import Content from "./Content";
import Footer from "./Footer";
import GoalsList from "./GoalsList";
import SidePanel from "./SidePanel";
import { useSelector } from "react-redux";
import { BrowserRouter as Router } from 'react-router-dom';

const Page = () => {
    const goals = useSelector(state => state.integrationGoals.goals);
    const selectedGoals = useSelector(state => state.integrationGoals.selectedGoals);

    const findUniqueGoals = (array) => {
        let ar = [];
        array.forEach(goal => {ar[goal.goalId] = goal})
        return ar.filter(i => i !== undefined);
    }

    return (
        <div className="page">
            <Header/>
            <div className="content-container">
                <Content/>
                <GoalsList goals={findUniqueGoals(goals)} 
                           selectedGoals={selectedGoals}/>
            </div>
            <Router>
                <SidePanel/>
            </Router>    
            <Footer/>
        </div>
    );
}

export default Page;
